function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

(async () => {
  const { loadScript: e, hideElement: t } = await import(
    window.theme.modules.utils
  );
  var s = await import(window.theme.modules.baseComponent);
  customElements.define(
    "google-map",
    class extends s.default {
      constructor(...args) {
        super(...args);

        _defineProperty(this, "elements", {
          styleJSON: "[data-style-json]",
        });

        _defineProperty(this, "willLoad", !0);
      }

      render() {
        this.mapStyle = JSON.parse(this.$styleJSON.textContent);
      }

      onAuthError() {
        (this.willLoad = !1), t(this);
      }

      async onIntersect(e) {
        e && !this.map && this.willLoad && (await this._initMap());
      }

      async _initMap() {
        var _window$google, _window$google$maps;

        ((_window$google = window.google) !== null &&
          _window$google !== void 0 &&
          (_window$google$maps = _window$google.maps) !== null &&
          _window$google$maps !== void 0 &&
          _window$google$maps.Map) ||
          (await e(
            `https://maps.googleapis.com/maps/api/js?key=${this.getAttribute(
              "api-key"
            )}`
          )),
          (this.geo = new window.google.maps.Geocoder()),
          this.geo.geocode(
            {
              address: this.getAttribute("address"),
            },
            (e, t) => {
              if (
                (console.log(t), t === window.google.maps.GeocoderStatus.OK)
              ) {
                const s = e[0].geometry.location;

                this._renderMap(s.lat(), s.lng());
              } else console.error(t);
            }
          );
      }

      _renderMap(e, t) {
        (this.map = new window.google.maps.Map(this, {
          center: {
            lat: e,
            lng: t,
          },
          zoom: 12,
          disableDefaultUI: !0,
          styles: this.mapStyle,
        })),
          window.google.maps.event.addListenerOnce(this.map, "idle", () => {
            this.setAttribute("loaded", "");
          }),
          this._setMarker();
      }

      _setMarker() {
        var e = `<svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 384 512"><path fill="${this.getAttribute(
          "marker-color"
        )}" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"/></svg>`;
        const t = new window.google.maps.Marker({
          position: this.map.getCenter(),
          map: this.map,
          icon: {
            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(e),
            scaledSize: new window.google.maps.Size(30, 30),
          },
        });
        t.addListener("click", () => {
          this.hasAttribute("directions-url") &&
            window.open(this.getAttribute("directions-url"), "_blank");
        });
      }
    }
  );
})();
